// Глобальна директива v-lazy для зображень.
// Завантажує картинку лише коли вона потрапляє у вьюпорт (IntersectionObserver),
// з невеликим запасом, щоб картинка встигала з'явитись до того, як користувач доскролить.

const SUPPORTS_IO = typeof window !== "undefined" && "IntersectionObserver" in window;

// Прозорий 1x1 placeholder — щоб до завантаження не показувались
// alt-текст і іконка "битого зображення", а лишався чистий shimmer-фон.
const PLACEHOLDER =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

let observer = null;

function loadImage(el) {
  const src = el.dataset.src;
  if (!src || el.dataset.loaded === "true") return;
  const img = new Image();
  img.onload = () => {
    el.src = src;
    el.dataset.loaded = "true";
    el.classList.add("lazy-loaded");
  };
  img.onerror = () => {
    el.src = src;
    el.dataset.loaded = "true";
    el.classList.add("lazy-loaded");
  };
  img.src = src;
}

function getObserver() {
  if (observer) return observer;
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadImage(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "200px 0px" }
  );
  return observer;
}

function observe(el, value) {
  if (!value) return;
  el.dataset.src = value;
  el.dataset.loaded = "false";
  el.classList.add("lazy-img");
  // Підставляємо прозорий placeholder одразу, щоб не блимали alt-текст / битий значок
  if (el.tagName === "IMG" && el.getAttribute("src") !== value) {
    el.src = PLACEHOLDER;
  }
  if (SUPPORTS_IO) {
    getObserver().observe(el);
  } else {
    // Фолбек для старих webview — вантажимо одразу
    loadImage(el);
  }
}

export default {
  bind(el, binding) {
    observe(el, binding.value);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      if (SUPPORTS_IO && observer) observer.unobserve(el);
      el.classList.remove("lazy-loaded");
      observe(el, binding.value);
    }
  },
  unbind(el) {
    if (SUPPORTS_IO && observer) observer.unobserve(el);
  },
};
